export default __webpack_public_path__ + "static/media/sc2.b624863b.png";